import { render, staticRenderFns } from "./surcharge-manager.vue?vue&type=template&id=35742e32&"
import script from "./surcharge-manager.vue?vue&type=script&lang=js&"
export * from "./surcharge-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports